const Utility = {};

Utility.toHtmlText = (value) => {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value, null, 3);
  }
  return value;
};

export default Utility;
